import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/Accordion';
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const faqs = [{
    question: '¿Necesito mucho dinero para empezar?',
    answer: 'No, puedes montar tu sistema inicial con menos de $25-30 en materiales básicos.'
  }, {
    question: '¿Mi balcón es demasiado pequeño?',
    answer: 'Si cabe una silla, cabe un huerto de 3 macetas. Optimizamos la verticalidad.'
  }, {
    question: '¿Qué pasa si mi balcón es muy oscuro?',
    answer: 'Te enseñamos a cultivar especies de sombra como espinacas y berros que brillan sin sol directo.'
  }, {
    question: '¿Atrae bichos?',
    answer: 'Con nuestra mezcla de sustrato limpia y los consejos de control preventivo, las plagas no serán un problema en tu piso.'
  }];
  return <section ref={ref} className="w-full py-10 md:py-16 bg-white" data-id="element-55">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-57">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-[#2D6A4F] mb-3" data-id="element-58">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-59">
          <Accordion type="single" defaultValue="item-0" data-id="element-60">
            {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} data-id="element-61">
                <AccordionTrigger className="text-left text-base font-medium text-[#2D6A4F]" data-id="element-62">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-700 text-sm leading-relaxed" data-id="element-63">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </motion.div>
      </div>
    </section>;
}